import { GearInstance, StepperStep } from 'types';
import { getCommonFormProps } from './commonData';

export const getCancellationFeeStep = (
  instance: GearInstance,
  onPass: (data: any, toDraft?: boolean) => void,
): StepperStep => ({
  stepName: 'Rental Agreement',
  onPass: async (data: any) => {
    onPass(data);
  },
  formProps: {
    buttonCaption: 'Publish',
    isSlimFooter: false,
    ...getCommonFormProps(onPass),
    fields: [
      {
        type: 'secondTitle',
        fieldName: 'step_title',
        value: 'Rental Agreement',
      },
      {
        type: 'fileUploader',
        fieldName: 'rental_agreement',
        acceptedFormats: '.pdf',
        header: 'Upload Rental Agreement File (.pdf)',
        description: 'Max file size: 5MB',
        prefix: 'Agreement',
        value: instance.rental_agreement || '',
      },
    ],
  },
});
